// extracted by mini-css-extract-plugin
export default {"headerCardTitle":"CourseData_headerCardTitle__FI7l1","colTitle":"CourseData_colTitle__INxFz"};